import { useHistory } from 'react-router';

import ChangePlan from '@app/views/ChangePlan';
import { UsagePage } from '@app/views/Usage';

import { NestedRoutes, RouteRenderProps } from '../utils';
import { PlanLink } from '../constants';

const noop = () => {
  //noop
};

export const planRoutes: RouteRenderProps[] = [
  {
    path: PlanLink.Plan,
    render: <UsagePage />,
    exact: true,
    fromParent: 0,
  },
  {
    path: PlanLink.ChoosePlanFilter,
    render: <ChangePlan navigateToOverview={noop} navigateToPreviousPage={noop} />,
    exact: true,
    fromParent: 0,
  },
];

const createPlanRoutes = (navigateToPreviousPage: () => void, navigateToOverview: () => void) => {
  return [
    ...planRoutes.filter((routeObj) => routeObj.path !== PlanLink.ChoosePlanFilter),
    {
      path: PlanLink.ChoosePlanFilter,
      render: <ChangePlan navigateToPreviousPage={navigateToPreviousPage} navigateToOverview={navigateToOverview} />,
      exact: true,
      fromParent: 0,
    },
  ];
};

export const PlanSwitch = (): JSX.Element => {
  const history = useHistory();

  const navigateToPreviousPage = () => {
    history.goBack();
  };

  const navigateToOverview = () => {
    history.replace('/');
  };

  const routes = createPlanRoutes(navigateToPreviousPage, navigateToOverview);

  return <NestedRoutes routes={routes} />;
};
